import React from 'react';
import { ReactComponent as CheckmarkGreen } from '../../assets/icons/checkmark-green.svg';

interface IProps {
  // Gruppe-id fra RoleResponse/PermissionResponse/UserAccessResponse. Null = ikke koblet.
  entraSecurityGroupId?: string | null;
}

// Viser en indikator når en rolle/tilgang er koblet til en Entra-sikkerhetsgruppe. Tom ellers.
function SecurityGroupBadge({ entraSecurityGroupId }: IProps) {
  if (!entraSecurityGroupId) return null;

  return (
    <span title='Koblet til Entra-sikkerhetsgruppe'>
      <CheckmarkGreen className='checkmark' aria-label='Koblet til Entra-sikkerhetsgruppe' />
    </span>
  );
}

export default SecurityGroupBadge;
